import { type ConditionalEffect, CoreDsl, type ViewQueryRecordNodeWithParent } from '@salescore/core'
import type { OrganizationSetting } from '@salescore/features'
import { logger } from '@salescore/frontend-common'
import { Record } from 'effect'

export const getActiveConditionalEffects = (
  conditionalEffects: ConditionalEffect[] | undefined,
  recordNode: ViewQueryRecordNodeWithParent,
  snapshot: Record<string, Record<string, unknown>>,
  setting?: OrganizationSetting,
): ConditionalEffect[] => {
  if (conditionalEffects === undefined) {
    return []
  }

  const result = conditionalEffects.filter((effect) => {
    const result = CoreDsl.compileWithRecordNode(effect.condition, recordNode, { snapshot, setting })
    if (Record.toEntries(snapshot).length > 0) {
      // 2023/05 本番での検証のため、しばらくログ表示しておく

      logger.debug('effects for snapshot', snapshot, result, effect)
    }
    return result.success && result.data === true
  })
  return result
}
